import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

type PromoColorMode = 'light' | 'dark' | null;

const INITIAL_REVEAL_MS = 5000;

@Component({
  selector: 'andor-promo-button',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './promo-button.html',
  styleUrl: './promo-button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromoButton {
  colorMode = input<PromoColorMode>(null);

  inverseColorMode = computed<PromoColorMode>(() => {
    switch (this.colorMode()) {
      case 'dark':
        return 'light';
      case 'light':
        return 'dark';
      default:
        return null;
    }
  });

  protected revealed = signal(true);

  constructor() {
    const timer = setTimeout(() => this.revealed.set(false), INITIAL_REVEAL_MS);
    inject(DestroyRef).onDestroy(() => clearTimeout(timer));
  }
}
